export default (Vue) => {
    Vue.directive('outsideclick', {
        bind(el, binding) {
            function clickHandler(e) {
                if (el.contains(e.target)) {
                    return false;
                }
                if (binding.expression) {
                    binding.value(e);
                }
            }
            el.__vueClickOutside__ = clickHandler;
            document.addEventListener('click', clickHandler);
        },
        update() {},
        unbind(el) {
            document.removeEventListener('click', el.__vueClickOutside__);
            delete el.__vueClickOutside__;
        }
    });
    Vue.directive('outsidetouchstart', {
        bind(el, binding) {
            function clickHandler(e) {
                if (el.contains(e.target)) {
                    return false;
                }
                if (binding.expression) {
                    binding.value(e);
                }
            }
            el.__vueClickOutsideTouch__ = clickHandler;
            document.addEventListener('touchstart', clickHandler);
        },
        update() {},
        unbind(el) {
            document.removeEventListener(
                'touchstart',
                el.__vueClickOutsideTouch__
            );
            delete el.__vueClickOutsideTouch__;
        }
    });
};
